import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const CANVAS_WIDTH = 1280;
const PAGE_WIDTH = 9;

export const generatePdfReport = async (fileName) => {
  // eslint-disable-next-line new-cap
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'in',
    format: 'letter',
    compress: true,
  });

  let firstPage = true;
  for (let input of document.getElementsByClassName('print-page')) {
    const elements = input.getElementsByClassName('candidate-profile-assessments');
    if (elements.length > 0) {
      let hasHeader = false;
      for (let header of input.getElementsByClassName('report-pdf-header')) {
        header.classList.add('candidate-profile-pdfheader');
        hasHeader = true;
      }
      const canvas = await html2canvas(input, {
        windowWidth: CANVAS_WIDTH,
        width: CANVAS_WIDTH,
        scale: 2,
      });
      const imageHeight = (PAGE_WIDTH / canvas.width) * canvas.height;
      const imgData = canvas.toDataURL('image/png', 1);
      let marginTop = 0.25;
      if (!firstPage) {
        pdf.addPage();
      } else {
        firstPage = false;
      }

      if (hasHeader) {
        marginTop = 0;
      }

      // eslint-disable-next-line new-cap
      pdf.addImage({
        imageData: imgData,
        x: -((PAGE_WIDTH - 8.5) / 2),
        y: marginTop,
        width: PAGE_WIDTH,
        height: imageHeight,
      });
      for (let header of input.getElementsByClassName('report-pdf-header')) {
        header.classList.remove('candidate-profile-pdfheader');
      }
    }
  }

  const pages = pdf.internal.getNumberOfPages();
  const pageWidth = pdf.internal.pageSize.width;
  const pageHeight = pdf.internal.pageSize.height;
  const horizontalPos = pageWidth - pageWidth * 0.1;
  const verticalPos = pageHeight - 0.5;

  pdf.setFontSize(9);
  pdf.setTextColor('#212526');
  pdf.setFont('helvetica');

  for (let j = 1; j < pages + 1; j++) {
    pdf.setPage(j);
    pdf.text(`${j} of ${pages}`, horizontalPos, verticalPos, { align: 'right' });
  }

  pdf.save(fileName);
};
